import { PanelToolbar } from '../../components/panels/PanelToolbar';
import { ProcessingNotice } from '../../components/panels/ProcessingNotice';
import { DocumentPanel } from '../../components/panels/DocumentPanel';
import type { DocPanel } from '../../lib/types';

const DOC: DocPanel = {
  title: 'Prospect Summary',
  file: 'Tapis Deep 1-RDR1 Prospect Summary.pdf',
  page: 1,
  pageCount: 1,
  kind: 'geology',
};

const FACTS: [string, string][] = [
  ['Basin', 'PM515, Offshore Peninsular Malaysia'],
  ['Water Depth (m)', '65.0 m'],
  ['Basin/Geological Province', 'Malay Basin'],
  ['Basin Type', 'Mature'],
  ['Plays & Reservoir Targets', 'Group I'],
  ['Trap Type', '4-way dip closure'],
  ['Rock Risk(s)', 'Reservoir 90%/Anticline'],
  ['Hydrocarbon Phases', 'Gas'],
  ['Well POSS (m) TVDSS', '3105'],
  ['Pressure & Temp @ FTD', '135.6 psi / 19.68 ppg, 191 degC °C / 376°F (High Case)'],
  ['Well Total / Trajectory', 'Exploration / Vertical'],
  ['Environment(s) (%)', 'CO₂ / normally, H₂S (nil), N₂ (nil), Sulfur (nil)'],
  ['Nearby Facilities (dist km)', 'Tapis F Platform (2.5km NW)'],
  ['Well Cost (MM) / Year', 'USD 4.84 MM (mid-2027) @ 2026'],
];

export function WellDiagram() {
  return (
    <div className="splitpane">
      <section className="panel" aria-label="Well diagram">
        <PanelToolbar title="WELL DIAGRAM" accent options={['WELL DIAGRAM', 'RT OPS UPDATE']} />
        <ProcessingNotice />
      </section>

      <DocumentPanel doc={DOC} onPrev={() => undefined} onNext={() => undefined}>
        <article className="paper prospect" aria-label="Prospect summary">
          <header className="prospect-band">
            <span>Prospect Summary</span>
            <b>PM515 – TAPIS DEEP-1RDR1</b>
          </header>

          <div className="prospect-grid">
            <div className="prospect-thumb prospect-thumb--map" aria-hidden="true" />
            <div className="prospect-thumb prospect-thumb--column" aria-hidden="true" />
            <div className="prospect-thumb prospect-thumb--depth" aria-hidden="true" />
          </div>

          <table className="prospect-facts">
            <tbody>
              {FACTS.map(([k, v]) => (
                <tr key={k}>
                  <th scope="row">{k}</th>
                  <td>{v}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="prospect-grid prospect-grid--seismic">
            <div className="prospect-thumb prospect-thumb--seismic" aria-hidden="true" />
            <div className="prospect-thumb prospect-thumb--seismic" aria-hidden="true" />
          </div>

          <h4 className="prospect-sub">GROSS PROSPECT RESOURCES</h4>
          <table className="prospect-facts prospect-facts--numeric">
            <thead>
              <tr>
                <th>Prospect / Built-up</th>
                <th>Play</th>
                <th>HC Type</th>
                <th>P90</th>
                <th>P50</th>
                <th>P10</th>
                <th>Mean</th>
                <th>Phase</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>PM515 Tapis Deep_2019</td>
                <td>61</td>
                <td>Gas (MMboe)</td>
                <td>128</td>
                <td>1601</td>
                <td>1848</td>
                <td>1922</td>
                <td>3</td>
              </tr>
            </tbody>
          </table>
        </article>
      </DocumentPanel>
    </div>
  );
}
